import { FC } from 'react'

import { RequestType } from '@/api/models/requests/lib/requests.types'
import { PageType } from '@/components/entities/requests/model/types'
import { EmptyRequestsPlug } from '@/components/entities/requests/ui/EmptyRequestsPlug'
import { RequestListItem } from '@/components/entities/requests/ui/RequestsList/RequestListItem'

type Props = {
  requests?: RequestType[]
  areFiltersApplied?: boolean
  pageType: PageType
  areQuickFiltersSelected?: boolean
  arePassesAvailable?: boolean
}

const RequestsList: FC<Props> = ({
  requests,
  areFiltersApplied,
  pageType,
  areQuickFiltersSelected,
  arePassesAvailable
}) => {
  const areFiltersSelected = !areQuickFiltersSelected && !areFiltersApplied

  if (pageType === PageType.Passes && !arePassesAvailable) {
    return
  }

  if (requests?.length === 0) {
    return <EmptyRequestsPlug areRequestsEmpty={areFiltersSelected} />
  }

  return requests?.map(request => (
    <RequestListItem key={request.guid} request={request} pageType={pageType} />
  ))
}

export default RequestsList
